import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import GameReturnStyled, { SVGReturn } from './GameReturn.styled';
import { onCancelGame } from '../../../state-actions/onCancelGame';

const mapDispatchToProps = dispatch => ({
  onCancelGame: viewing => dispatch(onCancelGame(viewing))
});

export const GameReturn = ({ onCancelGame }) => (
  <GameReturnStyled title="Return" onClick={() => onCancelGame('selector')}>
    <SVGReturn xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 40">
      <title>Return</title>
      <path d="M15.7 22c0-.3.1-.5.3-.7l10.5-10.5c.4-.4 1.1-.4 1.6 0 .4.4.4 1.1 0 1.6L18.3 22l9.7 9.7c.4.4.4 1.1 0 1.6s-1.1.4-1.6 0L16 22.8c-.2-.2-.3-.5-.3-.8z" />
    </SVGReturn>
  </GameReturnStyled>);

export default connect(null, mapDispatchToProps)(GameReturn);

GameReturn.propTypes = {
  onCancelGame: PropTypes.func,
}

GameReturn.defaultProps = {
  onCancelGame: null,
}


// WEBPACK FOOTER //
// ./src/components/atoms/GameReturn/GameReturn.js